import { InstagramFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

interface IBTIconInstagramFilledProps extends IBTIconProps {
    isOnDark?: boolean;
}
export const BTIconInstagramFilled: FunctionComponent<IBTIconInstagramFilledProps> = (
    baseProps,
) => {
    const { isOnDark, ...iconProps } = baseProps;
    const [props] = useAntIcon(iconProps);

    return (
        <InstagramFilled
            {...props}
            className={cn("BTIconInstagramFilled", props.className, { isOnDark })}
        />
    );
};
